import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  account: AccountInfo | null = null;
  token: string | undefined;

  constructor(private msalService: MsalService) {
    this.account = this.msalService.instance.getActiveAccount();
  }

  isLoginRedirected(): boolean {
    return window.location.hash.includes('code=');
  }

  isLoggedIn(): boolean {
    return this.account != null;
  }

  isAdmin(): boolean {
    const roles = this.account?.idTokenClaims?.roles as string[] | undefined;
    if (!roles) {
      return false;
    }
    return roles.includes('Admin');
  }

  isAccountant(): boolean {
    const roles = this.account?.idTokenClaims?.roles as string[] | undefined;
    if (!roles) {
      return false;
    }
    return !roles.includes('Admin') && roles.includes('Accountant');
  }

  isUnderwriter(): boolean {
    const roles = this.account?.idTokenClaims?.roles as string[] | undefined;
    if (!roles) {
      return false;
    }
    return !roles.includes('Admin') && roles.includes('Underwriter');
  }

  getUserRole(): string | null {
    if (this.isAdmin()) {
      return 'Admin';
    } else if (this.isAccountant()) {
      return 'Accountant';
    } else if (this.isUnderwriter()) {
      return 'Underwriter';
    } else {
      return null;
    }
  }

  getUserName(): string | null {
    return this.account?.name || null;
  }

  login() {
    if (!this.isLoggedIn()) {
      this.msalService.loginRedirect({
        scopes: environment.APP_SCOPES,
        prompt: 'consent'
      });
    }
  }

  logout() {
    if (this.isLoggedIn()) {
      this.msalService.logoutRedirect();
    }
  }
}
